import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('klaviyo'),
  titleToNamespace: true,
  avatarPath: avatars.klaviyo,
  logoPath: logos.klaviyo,
  hasConnectionStatus: false,
  defaultAuthenticationType: 'searchParams'
});
